import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import OrderInfo from '../components/order';

formCreate.component('OrderInfo', OrderInfo);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'directly_order_form',
      formParentCode: 'CRM20211110000002766',
    };
  },

  methods: {

    async formComplete() {
      if (this.formConfig.code === 'view' || this.formConfig.code === 'edit') {
        const data = await request.post('/sfa/sfaWorkDailyController/loadEditPageForWorkbenchOrder', { bizId: this.formConfig.row.id }).then((res) => (res.success ? res.result : []));
        const sfaVisitStepOrderItems = this.getRule('sfaVisitStepOrderItems');
        sfaVisitStepOrderItems.props = {
          code: this.formConfig.code,
          ...sfaVisitStepOrderItems.props,
          value: data.sfaVisitStepOrderItems,
          detailData: data,
          formConfig: this.formConfig,
        };
        this.setValue(data);
      }
    },
  },
};
